<template>
  <div v-if="showBadge" :class="badgeClass" :title="tooltipText">
    <template v-if="branch === 'dev'">
      {{ branch }} - {{ shortCommit }}
    </template>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';

const branch = ref<string | null>(null);
const version = ref<string | null>(null);

const showBadge = computed(() => {
  // Hide on production branches
  return branch.value && !['main', 'master', 'unknown'].includes(branch.value);
});

const shortCommit = computed(() => {
  // Extract commit hash from version (format: "abc1234-20231229T163015")
  if (!version.value) return '';
  return version.value.split('-')[0] || '';
});

const badgeClass = computed(() => ({
  'env-badge': true,
  'env-badge--dev': branch.value === 'dev',
  'env-badge--qa': branch.value === 'qa' || branch.value === 'staging'
}));

const tooltipText = computed(() =>
  `Branch: ${branch.value}\nVersion: ${version.value}`
);

onMounted(async () => {
  try {
    const response = await fetch('/api/version');
    const data = await response.json();
    branch.value = data.branch;
    version.value = data.version;
  } catch (error) {
    console.warn('Failed to fetch version info:', error);
  }
});
</script>

<style scoped>
.env-badge {
  position: fixed;
  top: 12px;
  right: 16px;
  z-index: 9999;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  font-family: monospace;
  padding: 2px 8px;
  border-radius: 4px;
  cursor: default;
  white-space: nowrap;
}

.env-badge--dev {
  background-color: #f59e0b;
  color: #000;
}

.env-badge--qa {
  background-color: #f97316;
  width: 16px;
  height: 16px;
  padding: 0;
  border-radius: 3px;
}
</style>
